import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  Stack
} from '@mui/material'

import { Dialog as DialogModel } from '@/contexts/dialogs'

type AlertDialogProps = DialogModel &
  DialogProps & {
    onClose: (_value: boolean) => void
    onExited?: (_node: HTMLElement) => void
  }

const AlertDialog = ({
  open,
  message,
  confirm = 'ok',
  startIcon,
  endIcon,
  onClose,
  onExited
}: AlertDialogProps) => (
  <Dialog
    open={open}
    maxWidth="xs"
    onClose={() => onClose(false)}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    slotProps={{ paper: { sx: { margin: 0 } }, transition: { onExited } }}
    sx={{ justifyContent: 'center' }}
  >
    <DialogContent dividers={true} sx={{ p: 4 }}>
      <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ p: 2 }}>
      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          startIcon={startIcon}
          endIcon={endIcon}
          onClick={() => onClose(true)}
        >
          {confirm}
        </Button>
      </Stack>
    </DialogActions>
  </Dialog>
)

export default AlertDialog
